/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyConsumer from './pharmacy-consumer';
import PharmacyConsumerDetail from './pharmacy-consumer-detail';
import PharmacyConsumerUpdate from './pharmacy-consumer-update';
import PharmacyConsumerDeleteDialog from './pharmacy-consumer-delete-dialog';

const PharmacyConsumerRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyConsumer />} />
    <Route path="new" element={<PharmacyConsumerUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyConsumerDetail />} />
      <Route path="edit" element={<PharmacyConsumerUpdate />} />
      <Route path="delete" element={<PharmacyConsumerDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyConsumerRoutes;
